export default __webpack_public_path__ + "static/media/xdai.d1ed7492.svg";